import { c as _c } from "react/compiler-runtime";
import { ShareDialogAccessLevel } from "@components/access-level/share-dialog-access-level";
import { CopyLinkButton } from "@components/common/button/copy-link-button";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { SphereActionDivider } from "@components/common/sphere-action-divider";
import { Dialog, Divider } from "@flat-ui";
import { useHasValidFeatureProjectLevel } from "@hooks/feature-control/use-has-user-valid-feature-project-level";
import { useHasUserValidPermissionProjectLevel } from "@hooks/permission-control/use-has-user-valid-permission-project-level";
import { InviteMemberToSnapshot } from "@pages/project-details/project-snapshots/invite-member-to-snapshot";
import { SnapshotMembers } from "@pages/project-details/project-snapshots/snapshot-members";
import { getOpenSnapshotHref } from "@pages/project-details/project-snapshots/snapshot-utils";
import { defaultProjectLaunchTargetSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { canUserViewSnapshotMembers, isUserSnapshotAdmin } from "@utils/permission-control/snapshot-permission-control";
import { SnapshotEvents } from "@utils/track-event/track-event-list";

/** Locations from which the share snapshot dialog can be opened */

/** Reusable share dialog for a snapshot */
export function SnapshotShareDialog(t0) {
  const $ = _c(36);
  const {
    snapshot,
    isOpen,
    onClose,
    location,
    children: triggerButton
  } = t0;
  const {
    defaultOpenProjectTarget
  } = useAppSelector(defaultProjectLaunchTargetSelector);
  const {
    canInviteMembersToSnapshot
  } = useHasUserValidPermissionProjectLevel();
  const {
    canCreateSnapshot
  } = useHasValidFeatureProjectLevel();
  const canInvite = canInviteMembersToSnapshot && canCreateSnapshot;
  let t1;
  if ($[0] !== snapshot) {
    t1 = canUserViewSnapshotMembers(snapshot);
    $[0] = snapshot;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const canViewMembers = t1;
  let t2;
  if ($[2] !== defaultOpenProjectTarget || $[3] !== snapshot.id) {
    t2 = getOpenSnapshotHref({
      openTarget: defaultOpenProjectTarget,
      snapshotId: snapshot.id
    });
    $[2] = defaultOpenProjectTarget;
    $[3] = snapshot.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== location || $[6] !== snapshot.accessLevel || $[7] !== snapshot.id) {
    t3 = {
      name: SnapshotEvents.copySnapshotLink,
      props: {
        snapshotId: snapshot.id,
        accessLevel: snapshot.accessLevel,
        location
      }
    };
    $[5] = location;
    $[6] = snapshot.accessLevel;
    $[7] = snapshot.id;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <CopyLinkButton targetHref={t2} logEventParams={t3} />;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SphereActionDivider />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4) {
    t6 = <>{t4}{t5}</>;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== snapshot) {
    t7 = isUserSnapshotAdmin(snapshot);
    $[15] = snapshot;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== snapshot || $[18] !== t7) {
    t8 = <ShareDialogAccessLevel type="snapshot" entity={snapshot} isAccessLevelEditable={t7} location="snapshot-share-dialog" />;
    $[17] = snapshot;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== canInvite || $[21] !== snapshot) {
    t9 = canInvite && <><Divider sx={{
        my: SPACE_ELEMENTS_OF_MODAL
      }} /><InviteMemberToSnapshot snapshot={snapshot} /></>;
    $[20] = canInvite;
    $[21] = snapshot;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== canViewMembers || $[24] !== snapshot) {
    t10 = canViewMembers && <><Divider sx={{
        mt: SPACE_ELEMENTS_OF_MODAL,
        mb: "12px"
      }} /><SnapshotMembers snapshot={snapshot} location="snapshot-share-dialog" /></>;
    $[23] = canViewMembers;
    $[24] = snapshot;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== isOpen || $[27] !== onClose || $[28] !== t10 || $[29] !== t6 || $[30] !== t8 || $[31] !== t9) {
    t11 = <Dialog open={isOpen} onClose={onClose} title="Share snapshot" topRightActions={t6}>{t8}{t9}{t10}</Dialog>;
    $[26] = isOpen;
    $[27] = onClose;
    $[28] = t10;
    $[29] = t6;
    $[30] = t8;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t11 || $[34] !== triggerButton) {
    t12 = <>{triggerButton}{t11}</>;
    $[33] = t11;
    $[34] = triggerButton;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
}